<template>
  <a-modal
      :title="addressData ? '编辑地址' : '新增地址'"
      :visible="visible"
      :dialogStyle="{ minWidth: '800px' }"
      :bodyStyle="{ maxHeight: '800px', overflow: 'auto' }"
      :ok-button-props="{props: {loading}}"
      @cancel="$emit('update:visible', false)"
      @ok="handleOk"
  >
    <a-form :form="form" v-bind="formLayout">
      <a-form-item label="收货人">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请填写收货人'}] }]" />
      </a-form-item>
      <a-form-item label="联系方式">
        <a-input v-decorator="['phoneNumber', { rules: [{ required: true, validator: validators.mobile}] }]"/>
      </a-form-item>
      <a-form-item label="收货地址" required>
        <a-row :gutter="12">
          <a-col :md="12">
            <a-form-item style="margin-bottom: 0;">
              <a-select
                  v-decorator="['province', { rules: [{ required: true, message: '请选择省'}] }]"
                  labelInValue
                  placeholder="请选择省"
                  @change="handleProvinceChange"
              >
                <a-select-option v-for="province in districtTreeData" :key="province.id" :value="province.value">
                  {{ province.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12">
            <a-form-item style="margin-bottom: 0;">
              <a-select
                  v-decorator="['city', { rules: [{ required: true, message: '请选择市'}] }]"
                  labelInValue
                  placeholder="请选择市"
              >
                <a-select-option v-for="city in currentProvince.children" :key="city.id" :value="city.value">
                  {{ city.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item label="详细地址">
        <a-input v-decorator="['detailedAddress', { rules: [{ required: true, message: '请填写详细地址'}] }]"/>
      </a-form-item>
      <a-form-item label="邮政编码">
        <a-input v-decorator="['postalCode']"/>
      </a-form-item>
      <a-form-item label="设置默认地址">
        <a-switch v-decorator="['ifDefaultAddress', { valuePropName: 'checked' }]"></a-switch>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { loadProvinceData } from "@/api/account";
import { isMobile } from '@/utils/common/validate'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    addressData: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.validators = {
      mobile: (rule, value, callback) => {
        let info = '手机号码格式不正确!'
        if (value && !isMobile(value)) {
          callback(info)
        } else if (!value) {
          info = '请填写手机号码'
          callback(info)
        }
        callback()
      }
    }
    return {
      form: this.$form.createForm(this),
      districtTreeData: [],
      currentProvince: []
    }
  },
  watch: {
    visible (val) {
      if (val) {
        if (this.addressData) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              ...this.addressData,
              ifDefaultAddress: !!this.addressData.ifDefaultAddress,
              province: {
                key: this.addressData?.parentCode,
                label: this.addressData?.parentCodeName
              }
            })
            this.handleProvinceChange({
              key: this.addressData.parentCode,
              label: this.addressData.parentCodeName
            })
            this.form.setFieldsValue({
              city: {
                key: this.addressData?.code,
                label: this.addressData?.codeName
              }
            })
          })
        }
      } else {
        this.form.resetFields()
        this.currentProvince = []
      }
    }
  },
  mounted () {
    this.getProvinceData()
  },
  methods: {
    getProvinceData () {
      loadProvinceData().then(res => {
        this.districtTreeData = res.data.map((d, i) => {
          return {
            id: '' + i,
            value: d.code,
            title: d.name,
            children: [],
            selectable: false
          }
        })
      })
    },
    async handleProvinceChange (province) {
      this.form.resetFields('city')
      this.currentProvince = this.districtTreeData.find(data => data.value === province.key)
      await this.loadCityData(this.currentProvince)
    },
    loadCityData (data) {
      if (data.children.length) return
      loadProvinceData({ parentCode: data.value }).then(res => {
        if (data) {
          data.children = res.data.map((d, i) => {
            return {
              id: data.id + '-' + i,
              value: d.code,
              title: d.name,
              isLeaf: true
            }
          })
        }
      })
    },
    handleOk () {
      const {
        form: { validateFields }
      } = this
      // 先校验，通过表单校验后，才进入下一步
      validateFields((err, values) => {
        if (!err) {
          const data = {
            ...values,
            parentCode: values.province?.key,
            parentCodeName: values.province?.label,
            code: values.city?.key,
            codeName: values.city?.label,
            ifDefaultAddress: values.ifDefaultAddress ? 1 : 0
          }
          delete data.province
          delete data.city
          this.$emit('ok', this.addressData ? {...this.addressData, ...data} : {...data})
        }
      })
    }
  }
}
</script>